document.addEventListener("DOMContentLoaded", (event) => {
  console.log("DOM completamente cargado");

  setTimeout(() => {
    console.log("Han pasado 6 segundos desde que cargó la página");
  }, 6000);

  const observerOptions = {
    root: null, // usa el viewport como raíz
    rootMargin: '0px',
    threshold: 0 // activa la callback tan pronto como el elemento no sea visible
  };

  // Elementos que vas a observar y modificar
  const targetElement = document.querySelector('.product-form__buttons');
  const elementToChange = document.querySelector('#shopify-section-sections--25784360108374__custom_liquid_7eGyeM');

  // Verifica si los elementos existen para evitar errores
  if (!targetElement || !elementToChange) {
    return;
  }

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      // Si el elemento no está intersectando el viewport (está fuera de vista)
      if (!entry.isIntersecting) {
        elementToChange.classList.add('out-of-view');
      } else {
        elementToChange.classList.remove('out-of-view');
      }
    });
  }, observerOptions);

  // Comienza a observar el elemento
  observer.observe(targetElement);

  // También maneja el caso de carga inicial
  // para evitar que el estilo se aplique al cargar la página si el elemento ya está fuera de la vista
  const initialEntry = [{ isIntersecting: targetElement.getBoundingClientRect().top >= 0 && targetElement.getBoundingClientRect().bottom <= window.innerHeight }];
  initialEntry.forEach(entry => {
    if (!entry.isIntersecting) {
      elementToChange.classList.add('out-of-view');
    }
  });
});